export const disabled = '-is-disabled';
export const open = '-is-open';
export const expanded = '-is-expanded';
export const faded = '-is-faded';
export const visible = '-is-visible';
export const active = '-is-active';
export const saved = '-is-saved';
export const unsaved = '-is-unsaved';
